import { TextField } from '@material-ui/core';
import { Button, ValidationError } from '../../components';
import React from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState } from 'draft-js';
import { EcommerceService } from '../../services';
import { stateToHTML } from 'draft-js-export-html';
import { injectIntl } from '../../utils/reactIntl';
import '../LayoutWrapperMain/LayoutWrapperMain.global.scss';
import '../UserInfoSendNotification/userinfosendnotification.global.scss';

interface Props {
  handleModalClose: any;
  intl: any;
  id: any,
  serviceInfo: any
  setShowOverlay: any
}

const EcommerceSendNotification: React.FC<Props> = (props: Props) => {
  const {
    handleModalClose,
    id,
    serviceInfo,
    setShowOverlay,
    intl,
  } = props;
  const [editorState, setEditorState] = React.useState(EditorState.createEmpty());
  const [sendNotification, setSendNotification] = React.useState(true);
  const [showEmailNotification, setShowEmailNotification] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [showSMSNotification, setShowSMSNotification] = React.useState(false);
  const [showPushNotification, setShowPushNotification] = React.useState(false);
  const [emailTitle, setEmailTitle] = React.useState('');
  const [pushNotification, setPushNotification] = React.useState({
    title: '',
    message: '',
  });
  const [emailNotificationError, setEmailNotificationError] = React.useState({
    title: false,
    message: '',
  });
  const [smsNotificationError, setSMSNotificationError] = React.useState({
    message: '',
  });
  const [pushNotificationError, setPushNotificationError] = React.useState({
    title: '',
    message: '',
  });
  return (
    <>
      {
        sendNotification && (
          <div>
            <div className="sendNotification">
              <Button
                className="buttoNot"
                onClick={() => {
                  setShowEmailNotification(true);
                  setSendNotification(false);
                }}
              >
                {intl.formatMessage({ id: 'ChannelSendNotification.label.emailnotification' })}
              </Button>
              <Button
                className="buttoNot"
                onClick={() => {
                  setShowSMSNotification(true);
                  setSendNotification(false);
                }}
              >
                {intl.formatMessage({ id: 'ChannelSendNotification.label.smsnotification' })}
              </Button>
              <Button
                className="buttoNot"
                onClick={() => {
                  setShowPushNotification(true);
                  setSendNotification(false);
                }}
              >
                {intl.formatMessage({ id: 'ChannelSendNotification.label.pushnotification' })}
              </Button>
            </div>
          </div>
        )
      }
      {
        showEmailNotification && (
          <div>
            <h2>{intl.formatMessage({ id: 'ChannelSendNotification.label.emailnotification' })}</h2>
            <TextField
              onChange={(e) => {
                setEmailTitle(e.target.value);
              }}
              id="emailTitle"
              label={intl.formatMessage({ id: 'ChannelSendNotification.label.email' })}
              name="textField"
              variant="outlined"
              style={{ width: '100%' }}
            />
            {emailNotificationError.title
              && <ValidationError error="Email title can not be empty" />}
            <Editor
              editorState={editorState}
              toolbarClassName="toolbarClassName"
              wrapperClassName="wrapperClassName"
              editorClassName="editorClassName"
              onEditorStateChange={(e) => setEditorState(e)}
              toolbar={{
                options: ['inline', 'textAlign'],
                inline: {
                  inDropdown: false,
                  className: undefined,
                  component: undefined,
                  dropdownClassName: undefined,
                  options: ['bold', 'italic', 'underline'],
                },
                textAlign: {
                  inDropdown: false,
                  className: undefined,
                  component: undefined,
                  dropdownClassName: undefined,
                  options: ['left', 'center', 'right', 'justify'],
                },
              }}
            />
            {emailNotificationError.message === 'empty' && <ValidationError error="Email content can not be empty" />}
            {emailNotificationError.message === 'greater' && <ValidationError error="Email content can not be greater than 2000 alphabets" />}

            <div className="modal_footer">
              <Button
                className="margin_right"
                onClick={handleModalClose}
              >
                {intl.formatMessage({
                  id: 'ChannelSendNotification.label.cancel',
                })}
              </Button>
              <Button
                className="margin_right"
                onClick={() => {
                  if (emailTitle.length === 0) {
                    setEmailNotificationError({ ...emailNotificationError, title: true });
                  } else if (editorState.getCurrentContent().getPlainText().length === 0) {
                    setEmailNotificationError({ ...emailNotificationError, title: false, message: 'empty' });
                  } else if (editorState.getCurrentContent().getPlainText().length > 2000) {
                    setEmailNotificationError({ ...emailNotificationError, message: 'greater' });
                  } else {
                    setShowOverlay(true);
                    EcommerceService.sendEmail({
                      sessionId: id,
                      subject: emailTitle,
                      message: stateToHTML(editorState.getCurrentContent()),
                      userId: serviceInfo.data[0].userId,
                    }).then(() => {
                      setShowOverlay(false);
                      handleModalClose();
                    });
                  }
                }}
              >
                {intl.formatMessage({
                  id: 'ChannelSendNotification.label.notification',
                })}
              </Button>
            </div>
          </div>
        )
      }
      {
        showPushNotification && (
          <div>
            <h2>{intl.formatMessage({ id: 'ChannelSendNotification.label.push' })}</h2>
            <TextField
              onChange={(e) => {
                setPushNotification({
                  ...pushNotification,
                  title: e.target.value,
                });
              }}
              id="emailTitle"
              label={intl.formatMessage({ id: 'ChannelSendNotification.label.notification' })} // "ChannelSendNotification.label.notification"
              name="textField"
              placeholder="Email Title"
              variant="outlined"
              style={{ width: '100%' }}
            />
            {pushNotificationError.title === 'empty'
              && <ValidationError error="Notification title cannot be empty" />}
            {pushNotificationError.title === 'greater'
              && <ValidationError error="Notification title cannot be greater than 50 characters" />}
            <textarea
              placeholder={intl.formatMessage({ id: 'ChannelSendNotification.label.message' })}
              onChange={(e) => {
                setPushNotification({
                  ...pushNotification,
                  message: e.target.value,
                });
              }}
            />
            {pushNotificationError.message === 'empty'
              && <ValidationError error="Notification message cannot be empty" />}
            {pushNotificationError.message === 'greater' && <ValidationError error="Notification message cannot be greater than 150 alphabets" />}

            <div className="modal_footer">
              <Button
                className="margin_right"
                onClick={handleModalClose}
              >
                {intl.formatMessage({
                  id: 'ChannelSendNotification.label.cancel',
                })}
              </Button>
              <Button
                className="margin_right"
                onClick={() => {
                  if (pushNotification.title === '' && pushNotification.message === '') {
                    setPushNotificationError({ ...pushNotificationError, message: 'empty', title: 'empty' });
                  } else if (pushNotification.title.length > 50 && pushNotification.message.length > 150) {
                    setPushNotificationError({ ...pushNotificationError, title: 'greater', message: 'greater' });
                  } else if (pushNotification.title === '') {
                    setPushNotificationError({ ...pushNotificationError, title: 'empty', message: '' });
                  } else if (pushNotification.message === '') {
                    setPushNotificationError({ ...pushNotificationError, message: 'empty', title: '' });
                  } else if (pushNotification.title.length > 50) {
                    setPushNotificationError({ ...pushNotificationError, title: 'greater', message: '' });
                  } else if (pushNotification.message.length > 150) {
                    setPushNotificationError({ ...pushNotificationError, title: '', message: 'greater' });
                  } else {
                    setShowOverlay(true);
                    EcommerceService.sendPushNotification({
                      sessionId: id,
                      title: pushNotification.title,
                      message: pushNotification.message,
                      userId: serviceInfo.data[0].userId,
                    }).then(() => {
                      setShowOverlay(false);
                      handleModalClose();
                    });
                  }
                }}
              >
                {intl.formatMessage({
                  id: 'ChannelSendNotification.label.notification',
                })}
              </Button>
            </div>
          </div>
        )
      }
      {
        showSMSNotification && (
          <div>
            <h2>
              {intl.formatMessage({
                id: 'ChannelSendNotification.label.smsnotification',
              })}
            </h2>
            <textarea
              placeholder="Enter Message"
              onChange={(e) => {
                setMessage(e.target.value);
              }}
            />
            {smsNotificationError.message === 'empty'
              && <ValidationError error="SMS Message cannot be empty" />}
            {smsNotificationError.message === 'greater'
              && <ValidationError error="SMS cannot be greater than 120 alphabets" />}

            <div className="modal_footer">
              <Button
                className="margin_right"
                onClick={handleModalClose}
              >
                {intl.formatMessage({
                  id: 'ChannelSendNotification.label.cancel',
                })}
              </Button>
              <Button
                className="margin_right"
                onClick={() => {
                  if (message.length === 0) {
                    setSMSNotificationError({ ...smsNotificationError, message: 'empty' });
                  } else if (message.length > 120) {
                    setSMSNotificationError({ ...smsNotificationError, message: 'greater' });
                  } else {
                    setShowOverlay(true);
                    EcommerceService.sendSMS({
                      sessionId: id,
                      message,
                      userId: serviceInfo.data[0].userId,
                    }).then(() => {
                      setShowOverlay(false);
                      handleModalClose();
                    });
                  }
                }}
              >
                {intl.formatMessage({
                  id: 'ChannelSendNotification.label.notification',
                })}
              </Button>
            </div>
          </div>
        )
      }
    </>
  );
};

export default injectIntl(EcommerceSendNotification);
